export function isServer() {
    return typeof window === 'undefined';
}

export function isStatic() {
    return process.env.IS_STATIC;
}